import { id } from '@monorepo/tools/src/lib/types/primitives';
import { WebappsCidModel } from '../models/webapps-cid.model';

export function formatWebappsCidLabel(cid: id | number | string | undefined, name?: string): string {
	return `${cid} (${name || 'Unknown'})`;
}

export function toWebappsCidDropdownOptionLabels(cids: WebappsCidModel[]): string[] {
	return cids.map(item => formatWebappsCidLabel(item.getCid(), item.getName()));
}

export function findWebappsCidLabel(cids: WebappsCidModel[], selectedCid?: id | string, fallbackLabel?: string): string | undefined {
	if (selectedCid == null || selectedCid === '') {
		return undefined;
	}
	const match = cids.find(item => String(item.getCid()) === String(selectedCid));
	if (match) {
		return formatWebappsCidLabel(match.getCid(), match.getName());
	}
	return fallbackLabel ?? formatWebappsCidLabel(selectedCid);
}

export function findWebappsCidByOptionLabel(cids: WebappsCidModel[], optionLabel: string): WebappsCidModel | undefined {
	return cids.find(item => formatWebappsCidLabel(item.getCid(), item.getName()) === optionLabel);
}

export function parseCidFromWebappsCidOptionLabel(optionLabel: string): id | undefined {
	const cid = optionLabel.split(' ')[0];
	return cid || undefined;
}
